export default __webpack_public_path__ + "static/media/Startups_Chilenas.148658c5.svg";